import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, CreditCard, ShieldCheck, Sparkles, Lock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { homePathForRole } from '../utils/roleHome';
import QuoteRequestForm from '../components/quote/QuoteRequestForm';
import QuoteNeed from '../components/home/QuoteNeed';
import './OrderPage.css';

export default function OrderPage() {
  const { t } = useLanguage();
  const { user, isAuthenticated, loading } = useAuth();
  const q = t.quoteForm;

  if (loading) {
    return (
      <div className="order-page">
        <div style={{ minHeight: '50vh', display: 'grid', placeItems: 'center', color: '#64748b' }}>
          …
        </div>
      </div>
    );
  }

  // Utilisateur connecté : la commande en ligne est réservée au rôle client.
  if (isAuthenticated && user?.role !== 'client') {
    return (
      <div className="order-page">
        <section className="order-section" style={{ marginTop: 60 }}>
          <div className="container">
            <div className="order-denied">
              <div className="order-denied-icon">
                <Lock size={36} />
              </div>
              <h1>Commande réservée aux clients</h1>
              <p>
                La commande en ligne est uniquement accessible aux comptes clients.
                Accédez à votre espace pour gérer vos missions.
              </p>
              <Link to={homePathForRole(user?.role)} className="btn btn-primary">
                Accéder à mon espace
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="order-page">
      <header className="order-hero">
        <img src="/images/earth-map.jpg" alt="" className="order-hero-bg" aria-hidden="true" />
        <div className="container order-hero-inner">
          <span className="order-hero-badge">
            <Sparkles size={14} />
            Tarjemlek
          </span>
          <h1>{q.title}</h1>
          <p>{q.subtitle}</p>
          <ul className="order-hero-trust">
            <li>
              <Clock size={15} />
              {q.trust.fast}
            </li>
            <li>
              <CreditCard size={15} />
              {q.trust.payment}
            </li>
            <li>
              <ShieldCheck size={15} />
              {q.trust.secure}
            </li>
          </ul>
        </div>
      </header>

      <section className="order-section">
        <div className="container">
          <QuoteRequestForm />
        </div>
      </section>

      <QuoteNeed to="/devis" />
    </div>
  );
}
